import React from "react";
import { FilterInput } from "components/FilterInput";

export const isValidInput = (input) => {
    const newInputValue = typeof input === "string" && input.trim();

    if (newInputValue.length === 0) {
        return true;
    }

    const numberWithEndingPlusRegex = /^[\d]+\+$/;

    if (numberWithEndingPlusRegex.test(newInputValue)) {
        return true;
    }

    const intValue = Number(newInputValue);
    return !Number.isNaN(intValue);
};

export const FilterNumberInput = ({ dataTestId = "filter-number-input", ...rest }) => (
    <FilterInput
        errorText="Geen geldig nummer"
        isValidInput={isValidInput}
        dataTestId={dataTestId}
        autoComplete="do-not-autofill"
        {...rest}
    />
);
